"use strict";

exports.__esModule = true;
exports.Api = void 0;

var tslib_1 = require("tslib");
/* tslint:disable */


require("isomorphic-fetch");

var ApiError =
/** @class */
function () {
  function ApiError(message) {
    this.details = null;
    this.message = message;
  }

  return ApiError;
}();
/**
 *
 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */


var Api =
/** @class */
function () {
  function Api() {
    this.baseUrl = 'https://cms.sportnet.online/api/v3';
    this.token = '';
  }

  Api.prototype.serializeQueryParams = function (parameters) {
    return Object.keys(parameters).reduce(function (acc, p) {
      var param = parameters[p];

      if (typeof param === 'undefined' || param === '') {
        return acc;
      }

      return tslib_1.__spreadArrays(acc, [encodeURIComponent(p) + "=" + encodeURIComponent(String(parameters[p]))]);
    }, []).join('&');
  };

  Api.prototype.transformParameter = function (value, transformOperation) {
    switch (transformOperation) {
      case 'joinUsingPipes':
        return Array.isArray(value) ? value.join('|') : value;

      default:
        return value;
    }
  };

  Api.prototype.setBaseUrl = function (baseUrl) {
    this.baseUrl = baseUrl;
  };

  Api.prototype.setToken = function (token) {
    this.token = token;
  };

  Api.prototype.appendAuthHeaders = function (headerParams) {
    var headers = new Headers(headerParams);

    if (this.token) {
      headers.append('Authorization', "Bearer " + this.token);
    }

    return headers;
  };

  Api.prototype.request = function (method, url, body, headers, queryParameters) {
    if (headers === void 0) {
      headers = new Headers();
    }

    if (queryParameters === void 0) {
      queryParameters = {};
    }

    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var queryParams, urlWithParams, form, k, response, responseContentType, err, _a;

      return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            queryParams = queryParameters && Object.keys(queryParameters).length ? this.serializeQueryParams(queryParameters) : null;
            urlWithParams = url + (queryParams ? '?' + queryParams : '');

            if (headers.get('Content-Type') === 'multipart/form-data') {
              form = new FormData();

              for (k in body) {
                form.append(k, body[k]);
              }

              body = form;
            } else if (headers.get('Content-Type') === 'application/json' && body && Object.keys(body).length > 0) {
              body = JSON.stringify(body);
            } else {
              body = undefined;
            }

            if (headers.get('Content-Type') === 'multipart/form-data') {
              headers["delete"]('Content-Type');
            }

            return [4
            /*yield*/
            , fetch(urlWithParams, {
              method: method,
              headers: headers,
              body: body
            })];

          case 1:
            response = _b.sent();
            if (!response.ok) return [3
            /*break*/
            , 2];
            responseContentType = response.headers && response.headers.get('Content-Type') || '';

            if (responseContentType.includes('application/json')) {
              return [2
              /*return*/
              , response.json()];
            } else if (responseContentType.includes('application/pdf')) {
              return [2
              /*return*/
              , response.blob()];
            } else if (responseContentType.includes('text/plain')) {
              return [2
              /*return*/
              , response.text()];
            }

            return [2
            /*return*/
            , {}];

          case 2:
            err = new ApiError(response.statusText);
            _a = err;
            return [4
            /*yield*/
            , response.json()];

          case 3:
            _a.details = _b.sent();
            throw err;
        }
      });
    });
  };
  /**
   * Get Doctypes for Contentspace
   * @method
   * @name Api#getDoctypes
   */


  Api.prototype.getDoctypes = function (appId, appSpace, contentDivider, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/doctypes';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Create Contentspace Doctype
   * @method
   * @name Api#postDoctype
   */


  Api.prototype.postDoctype = function (appId, appSpace, contentDivider, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/doctypes';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('POST', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
   * Delete Contentspace Doctype
   * @method
   * @name Api#deleteDoctype
   */


  Api.prototype.deleteDoctype = function (appId, appSpace, contentDivider, doctypeId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/doctypes/{doctype_id}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{doctype_id}', doctypeId.toString());
    return this.request('DELETE', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Edit Contentspace Doctype
   * @method
   * @name Api#editDoctype
   */


  Api.prototype.editDoctype = function (appId, appSpace, contentDivider, doctypeId, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/doctypes/{doctype_id}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{doctype_id}', doctypeId.toString());
    return this.request('PUT', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
    * Returns List of Articles with possibility to offset and limit results.
  Also possible to filter results by smarttags and doctype.
       * @method
    * @name Api#getArticles
    */


  Api.prototype.getArticles = function (appId, appSpace, contentDivider, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    queryParameters['offset'] = 0;

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
    queryParameters['limit'] = 50;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
    queryParameters['doctype'] = [];

    if (typeof parameters['doctype'] !== 'undefined') {
      queryParameters['doctype'] = parameters['doctype'];
    }

    queryParameters['doctype'] = this.transformParameter(queryParameters['doctype'], 'joinUsingPipes');
    queryParameters['smarttags'] = [];

    if (typeof parameters['smarttags'] !== 'undefined') {
      queryParameters['smarttags'] = parameters['smarttags'];
    }

    queryParameters['smarttags'] = this.transformParameter(queryParameters['smarttags'], 'joinUsingPipes');

    if (typeof parameters['sectionId'] !== 'undefined') {
      queryParameters['sectionId'] = parameters['sectionId'];
    }

    queryParameters['sectionId'] = this.transformParameter(queryParameters['sectionId']);

    if (typeof parameters['ids'] !== 'undefined') {
      queryParameters['ids'] = parameters['ids'];
    }

    queryParameters['ids'] = this.transformParameter(queryParameters['ids']);

    if (typeof parameters['excludeIds'] !== 'undefined') {
      queryParameters['excludeIds'] = parameters['excludeIds'];
    }

    queryParameters['excludeIds'] = this.transformParameter(queryParameters['excludeIds']);

    if (typeof parameters['ownerSportnetId'] !== 'undefined') {
      queryParameters['ownerSportnetId'] = parameters['ownerSportnetId'];
    }

    queryParameters['ownerSportnetId'] = this.transformParameter(queryParameters['ownerSportnetId']);

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);
    queryParameters['sorter'] = '-created';

    if (typeof parameters['sorter'] !== 'undefined') {
      queryParameters['sorter'] = parameters['sorter'];
    }

    queryParameters['sorter'] = this.transformParameter(queryParameters['sorter']);

    if (typeof parameters['validFrom'] !== 'undefined') {
      queryParameters['validFrom'] = parameters['validFrom'];
    }

    queryParameters['validFrom'] = this.transformParameter(queryParameters['validFrom']);

    if (typeof parameters['validTo'] !== 'undefined') {
      queryParameters['validTo'] = parameters['validTo'];
    }

    queryParameters['validTo'] = this.transformParameter(queryParameters['validTo']);

    if (typeof parameters['hasDraft'] !== 'undefined') {
      queryParameters['hasDraft'] = parameters['hasDraft'];
    }

    queryParameters['hasDraft'] = this.transformParameter(queryParameters['hasDraft']);
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Insert New Article with Given Properties
   * @method
   * @name Api#postArticle
   */


  Api.prototype.postArticle = function (appId, appSpace, contentDivider, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('POST', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
   * Edit Article Draft
   * @method
   * @name Api#editArticleDraft
   */


  Api.prototype.editArticleDraft = function (appId, appSpace, contentDivider, articleId, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles/{article_id}/draft';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{article_id}', articleId.toString());
    return this.request('PUT', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
   * Delete Article Draft
   * @method
   * @name Api#deleteArticleDraft
   */


  Api.prototype.deleteArticleDraft = function (appId, appSpace, contentDivider, articleId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles/{article_id}/draft';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{article_id}', articleId.toString());
    return this.request('DELETE', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Returns Article By ID
   * @method
   * @name Api#getArticle
   */


  Api.prototype.getArticle = function (appId, appSpace, contentDivider, articleId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles/{article_id}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{article_id}', articleId.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Edit Article By ID
   * @method
   * @name Api#editArticle
   */


  Api.prototype.editArticle = function (appId, appSpace, contentDivider, articleId, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles/{article_id}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{article_id}', articleId.toString());
    return this.request('PUT', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
   * Delete Article By ID
   * @method
   * @name Api#deleteArticle
   */


  Api.prototype.deleteArticle = function (appId, appSpace, contentDivider, articleId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/articles/{article_id}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{article_id}', articleId.toString());
    return this.request('DELETE', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Provide List of Static Contents
   * @method
   * @name Api#getStaticContents
   */


  Api.prototype.getStaticContents = function (appId, appSpace, contentDivider, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/static-content';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Insert New Static Content
   * @method
   * @name Api#postStaticContent
   */


  Api.prototype.postStaticContent = function (appId, appSpace, contentDivider, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/static-content';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('POST', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
   * Provide Detail of Static Content
   * @method
   * @name Api#getStaticContent
   */


  Api.prototype.getStaticContent = function (appId, appSpace, contentDivider, cid, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/static-content/{cid}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{cid}', cid.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Delete Static Content
   * @method
   * @name Api#deleteStaticContent
   */


  Api.prototype.deleteStaticContent = function (appId, appSpace, contentDivider, cid, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/admin/{appId}:{appSpace}:{contentDivider}/static-content/{cid}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{cid}', cid.toString());
    return this.request('DELETE', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#expandWidgets
   */


  Api.prototype.expandWidgets = function (appId, appSpace, contentDivider, parameters, body) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appId}:{appSpace}:{contentDivider}/expand-widgets';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('POST', "" + this.baseUrl + path, body, headers, queryParameters);
  };
  /**
   * Fetch Public Section By Id or UniqId
   * @method
   * @name Api#getPublicSectionByIdOrUniqId
   */


  Api.prototype.getPublicSectionByIdOrUniqId = function (appId, appSpace, contentDivider, sectionIdOrUniqId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appId}:{appSpace}:{contentDivider}/sections/{section_idOrUniqId}';
    var headers = new Headers();
    var queryParameters = {};
    headers = this.appendAuthHeaders(headers);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{section_idOrUniqId}', sectionIdOrUniqId.toString());
    queryParameters['expand_widgets'] = false;

    if (typeof parameters['expandWidgets'] !== 'undefined') {
      queryParameters['expand_widgets'] = parameters['expandWidgets'];
    }

    queryParameters['expand_widgets'] = this.transformParameter(queryParameters['expand_widgets']);
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Fetch Public Sections Tree
   * @method
   * @name Api#getPublicSectionsTree
   */


  Api.prototype.getPublicSectionsTree = function (appId, appSpace, contentDivider, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appId}:{appSpace}:{contentDivider}/sections-tree';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Fetch Public Section Tree By Id or Uniqid
   * @method
   * @name Api#getPublicSectionTreeByIdOrUniqId
   */


  Api.prototype.getPublicSectionTreeByIdOrUniqId = function (appId, appSpace, contentDivider, sectionIdOrUniqId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appId}:{appSpace}:{contentDivider}/sections/{section_idOrUniqId}/tree';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{section_idOrUniqId}', sectionIdOrUniqId.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Fetch Public Subsections By Id
   * @method
   * @name Api#getPublicSubsectionsByIdOrUniqId
   */


  Api.prototype.getPublicSubsectionsByIdOrUniqId = function (appId, appSpace, contentDivider, sectionIdOrUniqId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appId}:{appSpace}:{contentDivider}/sections/{section_idOrUniqId}/sections';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{section_idOrUniqId}', sectionIdOrUniqId.toString());
    queryParameters['treelevel'] = 0;

    if (typeof parameters['treelevel'] !== 'undefined') {
      queryParameters['treelevel'] = parameters['treelevel'];
    }

    queryParameters['treelevel'] = this.transformParameter(queryParameters['treelevel']);
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Fetch Section Path By Section Id
   * @method
   * @name Api#getPathForSectionId
   */


  Api.prototype.getPathForSectionId = function (appId, appSpace, contentDivider, sectionId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/public/{appId}:{appSpace}:{contentDivider}/sections/{section_id}/path';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appId}', appId.toString());
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{contentDivider}', contentDivider.toString());
    path = path.replace('{section_id}', sectionId.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Gets information from livestream url. Main purpose is for fetching video details and then later embeding it in iframe.
   * @method
   * @name Api#parseLivestreamUrl
   */


  Api.prototype.parseLivestreamUrl = function (parameters) {
    var path = '/public/parse-livestream-url';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    if (typeof parameters['url'] !== 'undefined') {
      queryParameters['url'] = parameters['url'];
    }

    queryParameters['url'] = this.transformParameter(queryParameters['url']);

    if (typeof parameters['url'] === 'undefined') {
      throw new Error('Missing required parameter: url');
    }

    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };

  return Api;
}();

exports.Api = Api;
exports["default"] = new Api();